import netsContactEdit from './nets-contact-edit';
import moduleConfig from './module-config';

export default angular
  .module('app.contact-edit', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsContactEdit', netsContactEdit);
